const ITEMS = ["ROHBAU", "UMBAU", "SANIERUNG", "GARTENBAU", "RENOVIERUNG", "OFFENBACH AM MAIN"];

export const Marquee = ({ reverse = false, outline = true }) => (
  <div className="relative overflow-hidden border-y border-line bg-ink py-6" aria-hidden="true">
    <div className={`flex w-max whitespace-nowrap ${reverse ? "animate-marquee-slower" : "animate-marquee-slow"}`}>
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className={`px-8 font-display text-4xl font-bold uppercase tracking-tight md:text-6xl ${outline ? "text-outline" : "text-ember"}`}>
                {item}
              </span>
              <span className="h-2 w-2 rotate-45 bg-ember" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
